(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gt-menu-letter-wave"] && !Shopify.designMode) return;
  try {
    (() => {
    const motion = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
    const selector = '.header__inline-menu > .list-menu > li > .header__menu-item, .header__inline-menu > .list-menu > li > header-menu > details > .header__menu-item';
    function rollMenuTitle(event) {
      if (!motion.matches || !(event.target instanceof Element)) return;
      const link = event.target.closest(selector);
      if (!link || (event.relatedTarget instanceof Node && link.contains(event.relatedTarget))) return;
      link.querySelectorAll('.gt-menu-roll__glyph').forEach((glyph) => {
        glyph.getAnimations().forEach((animation) => animation.cancel());
        glyph.animate([
          { transform: 'translateY(0)' },
          { transform: `translateY(${Number(glyph.dataset.direction) * 100}%)` }
        ], {
          duration: 700,
          // Cubic ease-out: same progress curve as power2.out.
          easing: 'cubic-bezier(0.333333, 1, 0.666667, 1)'
        });
      });
    }
    // Delegation also handles sections replaced by the Shopify theme editor.
    document.addEventListener('mouseover', rollMenuTitle);
    document.addEventListener('focusin', rollMenuTitle);
  })();
  } catch(e) { console.error(e); }
})();

})();
